import { EditorThemeClasses } from 'lexical';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListItemNode, ListNode } from '@lexical/list';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { HashtagNode } from '@lexical/hashtag';

import { CodeHighLightNode } from './nodes/CodeHighLightNode';
import { ImageNode } from './nodes/ImageNode';
import { AttachedNode } from './nodes/AttachedNode';
import { MentionNode } from './nodes/MentionNode';

const theme: EditorThemeClasses = {
  placeholder: 'iva-editor-placeholder',
  link: 'iva-editor-link',
  text: {
    bold: 'iva-editor-text-bold',
    italic: 'iva-editor-text-italic',
    underline: 'iva-editor-text-underline',
    strikethrough: 'iva-editor-text-strikethrough',
    // code: 'iva-editor-text-code',
  },
  list: {
    nested: {
      listitem: 'iva-editor-nested-listitem',
    },
    ol: 'iva-editor-list-ol',
    ul: 'iva-editor-list-ul',
    listitem: 'iva-editor-listitem',
  },
  // codeHighlight: {
  //   iva: 'iva-editor-text-code',
  // },
  image: 'iva-editor-image',
  attached: 'iva-editor-attach-file',
  paragraph: 'iva-editor-paragraph',
  table: 'iva-editor-table',
  tableRow: 'iva-editor-table-row',
  tableCell: 'iva-editor-table-cell',
  tableCellActionButton: 'iva-editor-table-cell-action-button',
  tableCellActionButtonContainer:
    'iva-editor-table-cell-action-button-container',
  tableCellHeader: 'iva-editor-table-cell-header',
  tableCellSelected: 'iva-editor-table-cell-selected',
  tableSelected: 'iva-editor-table-selected',
  tableCellPrimarySelected: 'iva-editor-table-cell-primary-selected',
  tableCellEditing: 'iva-editor-table-cell-editing',
  tableCellResizer: 'iva-editor-table-cell-resizer',
  tableAddColumns: 'iva-editor-table-add-columns',
  tableAddRows: 'iva-editor-table-add-rows',
  tableCellSortedIndicator: 'iva-editor-table-sorted-indicator',
  tableResizeRuler: 'iva-editor-table-resize-ruler',
};

export default {
  namespace: 'iva',
  theme,
  onError(err) {
    throw err;
  },
  nodes: [
    HeadingNode,
    ListNode,
    ListItemNode,
    QuoteNode,
    CodeNode,
    CodeHighlightNode,
    TableNode,
    TableCellNode,
    TableRowNode,
    AutoLinkNode,
    LinkNode,
    HashtagNode,
    CodeHighLightNode,
    ImageNode,
    AttachedNode,
    MentionNode,
  ],
};
